/**
 * utils/connectionPool/maintenance.ts — cleanup/destroy methods for ConnectionPoolManager
 */

import { ConnectionPoolManager } from './manager.js';

declare module './manager.js' {
  interface ConnectionPoolManager {
    cleanupIdleConnections(): void;
    destroy(): void;
  }
}

export function applyMaintenanceMethods() {
  Object.assign(ConnectionPoolManager.prototype, {
    /**
     * Clean up idle connections
     */
    cleanupIdleConnections(): void {
        const now = Date.now();
        const toDelete: string[] = [];

        for (const [id, conn] of this.connections) {
            if (
                !conn.inUse &&
                this.connections.size > this.config.minConnections &&
                now - conn.lastUsed > this.config.idleTimeout
            ) {
                toDelete.push(id);
            }
        }

        for (const id of toDelete) {
            this.connections.delete(id);
            if (import.meta.env.DEV) {
                console.log(`[Pool] Connection cleaned up: ${id}`);
            }
        }
    },

    /**
     * Destroy the connection pool and stop cleanup interval
     * Call this on app shutdown or page unload
     */
    destroy(): void {
        if (this.cleanupIntervalId !== null) {
            clearInterval(this.cleanupIntervalId);
            this.cleanupIntervalId = null;
            if (import.meta.env.DEV) {
                console.log('[Pool] Connection pool destroyed and cleanup interval stopped');
            }
        }
        this.connections.clear();
        (ConnectionPoolManager as any).instance = null;
    },
  });
}
